(function ($) {

    $(document).ready(function () {
        $("a[data-popuptarget]").on("click", function () {
            const target = $(this).data("popuptarget");
            const $popup = $("[data-popupid='" + target + "']");

            if ($popup.length) {
                $popup.addClass("popup--open");
                $("body").addClass("blur")
            }
        });

        $("body").on("click", ".popup__close, .popup__overlay", function () {
            if (!$(".popup--open").hasClass("popup--age")) {
                $(this).closest(".popup").removeClass("popup--open");
                $("body").removeClass("blur");
            }
        });
        
        $("body").on("click", ".popup--winehouse .popup__content a[href^='#']", function() {
            $(this).closest(".popup").removeClass("popup--open");
        });

        $(document).on("keyup", function (e) {
            if (e.which === 27) {
                if (!$(".popup--open").hasClass("popup--age")) {
                    $(".popup--open").removeClass("popup--open");
                    $("body").removeClass("blur");
                }
            }
        });

        if (!readCookie("agecheck")) {
            $(".popup--age").addClass("popup--open");
            $("body").addClass("blur");
        }

        $(".popup--age .arrow-link").on("click", function () {
            $(this).closest(".popup").removeClass("popup--open");
            $("body").removeClass("blur");
            createCookie("agecheck", "true", 365);
        });

        if ($(".popin").length) {
            $(".popin__close").on("click", function () {
                $(this).parent(".popin").removeClass("popin--open").addClass("popin--closed");
                createCookie("newsletter_closed", "true");
            });

            const $popin = $(".popin");
            const popinType = $($popin).data("popintype");
            const popinDelay = $($popin).data("popindelay");
            const newsletterSignedUp = readCookie("newsletter_closed");

            if (newsletterSignedUp !== "true") {
                switch (popinType) {
                    case "time":
                        setTimeout(function () {
                            $popin.addClass("popin--open");
                        }, popinDelay);
                        break;
                    case "scroll":
                        let scrollTimeout;

                        $(window).on("scroll", function () {
                            clearTimeout(scrollTimeout);

                            scrollTimeout = setTimeout(function () {
                                const scrollTop = $(document).scrollTop();
                                if (scrollTop > popinDelay) {
                                    $popin.addClass("popin--open");
                                }
                            }, 100);
                        });
                        break;
                }
            }

            $(".popin #mc-embedded-subscribe-form").on("submit", function (e) {
                let formInterval;
                
                formInterval = setInterval(function(){
                    const $response_succes = $("#mc-embedded-subscribe-form #mce-responses #mce-success-response");
                    
                    if ($($response_succes).css("display") === "block") {
                        clearInterval(formInterval);
                        
                        createCookie("newsletter_closed", "true");
                        
                        setTimeout(function(){
                            $(".popin--open").removeClass("popin--open").addClass("popin--closed");
                        }, 3000);
                    }
                },200);
            });
        }
        
        // Deliver these popups from the evil clutches of the sections containing them
        if ($(".popup--emancipate").length) {
            $(".popup--emancipate").each(function(){
                const parent = $(this).closest("section.content");
                $(this).detach().insertAfter(parent);
            });
        }
    });

})(jQuery);
